import React from 'react';
import { GridCellKind } from "@glideapps/glide-data-grid";
import { Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';

// Custom cell renderer for the VIEW/UPDATE button
export const ViewUpdateButtonRenderer = {
  kind: "view-update-button-cell",
  isMatch: (cell) => cell.data?.kind === "view-update-button-cell",
  draw: (args, cell) => {
    const { ctx, theme, rect, highlighted, hoverAmount } = args;
    const { x, y, width, height } = rect;
    
    // Draw background
    ctx.fillStyle = highlighted 
      ? `rgba(0, 0, 0, ${0.1 * hoverAmount})` 
      : "transparent";
    ctx.fillRect(x, y, width, height);
    
    // Draw button
    const buttonWidth = 100;
    const buttonHeight = 24;
    const buttonX = x + (width - buttonWidth) / 2;
    const buttonY = y + (height - buttonHeight) / 2;
    
    // Button background
    ctx.fillStyle = theme.accentColor;
    ctx.beginPath();
    ctx.roundRect(buttonX, buttonY, buttonWidth, buttonHeight, 4);
    ctx.fill();
    
    // Button text
    ctx.fillStyle = "#FFFFFF";
    ctx.font = "12px Inter, sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("VIEW/UPDATE", buttonX + buttonWidth / 2, buttonY + buttonHeight / 2);
    
    return true;
  },
  onClick: (cell, args) => {
    console.log('ViewUpdateButtonRenderer onClick called', cell.data);
    if (cell.data?.onClick && cell.data?.employeeId) {
      console.log('Calling onClick with employeeId:', cell.data.employeeId);
      cell.data.onClick(cell.data.employeeId);
      return true;
    }
    return false;
  },
  onSelect: (cell, args) => {
    // Prevent selection of this cell
    return false;
  },
  measure: () => {
    return 120; // Fixed width for the button cell
  }
};

// Helper function to create a VIEW/UPDATE button cell
export const createViewUpdateButtonCell = (employeeId, onClick) => {
  return {
    kind: GridCellKind.Custom,
    allowOverlay: true,
    readonly: true,
    copyData: "",
    data: {
      kind: "view-update-button-cell",
      employeeId,
      onClick
    }
  };
};